<template>
  <a v-if="href" class="button__link" :href="href" target="_blank">
    <slot />
  </a>
  <button v-else class="button__link" @click="showPopup = true">
    <slot />
  </button>

  <teleport to="body">
    <ModalTemplate v-if="showPopup" @close="showPopup = false">
      <div class="button__descr">
        Выберите маркет, в котором<br />Вы хотите продолжить
      </div>
      <div class="messenger-bot-links__options-list">
        <div
          class="button__bots"
          v-for="messenger in messengerLinks"
          :key="messenger.url"
        >
          <a class="button__bot" target="_blank" :href="messenger.url">
            <img :src="require(`@/assets/img/${messenger.image}`)" />
          </a>
        </div>
        (App Gallery для Huawei)
      </div>
    </ModalTemplate>
  </teleport>
</template>

<script>
import ModalTemplate from "@/components/ModalTemplate";

export default {
  name: "ButtonLink",
  components: {
    ModalTemplate,
  },
  props: {
    href: String,
    messengerLinks: [],
  },
  data() {
    return {
      showPopup: false,
    };
  },
};
</script>

<style scoped lang="scss">
.button {
  &__link {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    line-height: 17px;
    color: #ffffff;
    background: v-bind("color");
    border: 0px solid v-bind("color");
    cursor: pointer;
    min-height: 40px;
    transition: 0.2s;

    &:active {
      color: #000000;
      background: #ffffff;
    }
  }

  &__descr {
    padding: 10px;
    text-align: center;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  &__bots {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
  }

  &__bot {
    flex-basis: 90%;
    max-width: 100px;

    img {
      width: 100%;
    }
  }
}
</style>
